import Stack from '@mui/material/Stack';

interface IStepContainerProps {
    className: string;
    children: React.ReactNode[];
}

const StepContainer = ({ className, children }: IStepContainerProps) => (
    <Stack
        className={className}
        component="section"
        direction={{ xs: 'column', lg: 'row' }}
        spacing={{ xs: 4, sm: 5, lg: 10 }}
        useFlexGap
        sx={{ alignItems: { lg: 'center' } }}
    >
        {children}
    </Stack>
);

export default StepContainer;
